module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1021.4b85bc53.png";